// extracted by mini-css-extract-plugin
export default {"link":"Logout_link__JMg9g"};